import ImgWrapper from "components/global/ImgWrapper";
import dangerCircle from "assets/icons/dangerCircle.svg";
import dotsHorizontal from "assets/icons/dotsHorizontal.svg";
import userIcon from "assets/icons/userIconWhite.svg";

import { ConnectItem, Photo } from "./ManageChannelsStyles";
import { ConnectedOptions, socialIcons } from "./ManageChannels";

const Channels = ({ 
  brandId, 
  socials, 
  platformList, 
  handleConnectPlatform, 
  handleTokenRefresh, 
  handleRemoveChannel, 
  toggleShowOptions, 
  canConnectChannel, 
  connecting 
}) => {

  return (
    <>
      {socials?.map((channel, index) => {
        const { platform, page } = channel;

        return (
          <ConnectItem key={index} className="connected">
            <Photo>
              <ImgWrapper
                size={3.6}
                imgHeight={"1.6rem"}
                className="imgWrapper"
              >
                <img src={platform === "facebook" ? `https://graph.facebook.com/${page?.id}/picture?return_ssl_resources=true` : (page?.photo || userIcon)} alt="avi" />
              </ImgWrapper>
              <img
                src={socialIcons.circle[platform]}
                className="icon platformImg"
                alt="icon"
              />
            </Photo>
            <div className="text">
              <p className="connected l2 bold username">
                {page?.name}
              </p>
              {platform === "linkedin" && (
                <p className="colorBodyText l2 platform">
                  Linkedin {page?.category === "personal" ? "profile" : "page"}
                </p>
              )}
              {platform === "facebook" && (
                <p className="colorBodyText l2 platform">Facebook page</p>
              )}
              {platform === "instagram" && (
                <p className="colorBodyText l2 platform">Instagram Business</p>
              )}
              {platform === "twitter" && (
                <p className="colorBodyText l2">Twitter profile</p>
              )}
              {platform === "youtube" && (
                <p className="colorBodyText l2">Youtube channel</p>
              )}
              {platform === "tiktok" && (
                <p className="colorBodyText l2">TikTok Business</p>
              )}
            </div>
            <button
              type="button"
              className={`flexRow alignCenter refreshIndicator${
                !page?.is_access_token_valid ? " active" : ""
              }`}
              onClick={() => handleTokenRefresh(channel)}
            >
              <img src={dangerCircle} alt="danger" className="icon" />
              <span className="l2 colorDanger">Refresh</span>
            </button>
            <button
              type="button"
              className="toggleOptions"
              onClick={() => toggleShowOptions(`${platform}_${index + 1}`)}
            >
              <img src={dotsHorizontal} alt="options" className="icon" />
            </button>
            <ConnectedOptions
              handleRefresh={handleTokenRefresh}
              handleRemove={handleRemoveChannel}
              toggleShowOptions={toggleShowOptions}
              channel={channel}
              dataId={`${platform}_${index + 1}`}
              brandId={brandId}
            />
          </ConnectItem>
        );
      })}

      {!platformList?.includes("facebook") && (
        <ConnectItem data-disabled={!canConnectChannel.facebook}>
          <img
            src={socialIcons.default["facebook"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Facebook page</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() =>
              document
                .querySelector(".connectFacebookInfo")
                .classList.add("show")
            }
            disabled={connecting}
          >
            Connect
          </button>
        </ConnectItem>
      )}
      {!platformList?.includes("twitter") && (
        <ConnectItem data-disabled={!canConnectChannel.twitter}>
          <img
            src={socialIcons.default["twitter"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Twitter</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() => handleConnectPlatform("twitter")}
            disabled={connecting}
          >
            Connect
          </button>
        </ConnectItem>
      )}
      {!platformList?.includes("linkedin") && (
        <ConnectItem data-disabled={!canConnectChannel.linkedin}>
          <img
            src={socialIcons.default["linkedin"]}
            className="icon"
            alt="icon"
          />
          <span className="text">LinkedIn profile or page</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() => handleConnectPlatform("linkedin")}
            disabled={connecting}
          >
            Connect
          </button>
        </ConnectItem>
      )}
      {!platformList?.includes("youtube") && (
        <ConnectItem data-disabled={!canConnectChannel.youtube}>
          <img
            src={socialIcons.default["youtube"]}
            className="icon"
            alt="icon"
          />
          <span className="text">YouTube</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() => handleConnectPlatform("youtube")}
            disabled={connecting}
          >
            Connect
          </button>
        </ConnectItem>
      )}
      {!platformList?.includes("instagram") && (
        <ConnectItem data-disabled={!canConnectChannel.instagram}>
          <img
            src={socialIcons.default["instagram"]}
            className="icon"
            alt="icon"
          />
          <span className="text">Instagram Business</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() =>
              document
                .querySelector(".connectInstagramInfo")
                .classList.add("show")
            }
            disabled={connecting}
          >
            Connect
          </button>
        </ConnectItem>
      )}

      {!platformList?.includes("tiktok") && (
        <ConnectItem data-disabled={!canConnectChannel.tiktok}>
          <img
            src={socialIcons.default["tiktok"]}
            className="icon"
            alt="icon"
          />
          <span className="text">TikTok Business</span>
          <button
            className="colorGrey1 body-2 connect"
            onClick={() =>
              document
                .querySelector(".connectTiktokInfo")
                .classList.add("show")
            }
            disabled={connecting}
          >
            Connect
          </button>
        </ConnectItem>
      )}
    </>
  );
};

export default Channels;
